import {
  endpointKeys,
  PatientHealthJourneyUrlParams,
  PatientIdUrlParam,
  CushlaGetQueryOptions,
} from '@common/api'
import {
  patientHealthJourneyNormaliser,
  patientHealthJourneysNormaliser,
} from '@common/normalisers'
import {PatientHealthJourney} from '@common/models'

import {useWebGet, useApi} from './helpers'

export const useGetPatientHealthJourneys = (
  params: PatientIdUrlParam,
  options?: CushlaGetQueryOptions<PatientHealthJourney[]>,
) =>
  useWebGet<PatientHealthJourney[]>(
    [endpointKeys.patientHealthJourneys, params],
    useApi().patientHealthJourneys(params),
    patientHealthJourneysNormaliser,
    options,
  )

export const useGetPatientHealthJourney = (
  params: PatientHealthJourneyUrlParams,
  options?: CushlaGetQueryOptions<PatientHealthJourney>,
) =>
  useWebGet<PatientHealthJourney>(
    [endpointKeys.patientHealthJourney, params],
    useApi().patientHealthJourney(params),
    patientHealthJourneyNormaliser,
    options,
  )
